import React from "react";

import { useDataplanePrewarm } from "src/prewarm/useDataplanePrewarm";

/**
 * Renderless host for {@link useDataplanePrewarm}, so the warm-up keeps its
 * own mount point instead of riding on a layout component's lifecycle.
 */
export const DataplanePrewarm: React.FC = () => {
  useDataplanePrewarm();
  return null;
};
